import { render, staticRenderFns } from "./paymentForpayOptions.vue?vue&type=template&id=64068c52&scoped=true&"
import script from "./paymentForpayOptions.vue?vue&type=script&lang=js&"
export * from "./paymentForpayOptions.vue?vue&type=script&lang=js&"
import style0 from "./paymentForpayOptions.vue?vue&type=style&index=0&id=64068c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64068c52",
  null
  
)

export default component.exports